exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n#ticker[data-v-4726fee8] {\n  text-align: left;\n  position: absolute;\n  border-style: solid;\n  color: #ffd500;\n  border-color: #ffd500;\n  opacity: 0.8;\n  border-width: 1px;\n  height: 1px;\n  overflow: visible;\n  z-index: 1005;\n  font-size: 5vw;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-4726fee8","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Mobile/timetable/SpTicker.vue
// module id = 504
// module chunks = 0